import { LitElement, css, html } from 'lit'
import { LoadFaderMixin } from './dz-mixins.js'

/* 
    Специальный слайдер, который переключает карточки только в одну сторону.
    Для скрытия во время загрузки установите значение opacity:0 в месте использования элемента.
    Возможные направления top, bottom, right, left.
    Элементы должны быть проиндексированы с помощью data-index.
*/

export class DzSwitcher extends LoadFaderMixin(LitElement) {

    static get properties() {
        return {
          currentItem: { type: String },        // свойство для выбора карточки
          slideDirection: { type: String }, 
          delayTime: {type: Number }    // направление анимации
        }
    }

    constructor() {
        super()
        this.slideDirection = "top"
        this.currentItem = ""
        this.delayTime = 0
    }

    connectedCallback() {
        this.motionMap = {
            top:     { hide: `-${this.getBoundingClientRect().height}px`, show: `0px`, property: "top"},
            bottom:  { hide: `${this.getBoundingClientRect().height}px`, show: `0px`, property: "top"},
            right:   { hide: `${this.getBoundingClientRect().width}px`, show: `0px`, property: "left"},
            left:    { hide: `-${this.getBoundingClientRect().width}px`, show: `0px`, property: "left"},
        } 
        super.connectedCallback()
    }

    updated(changes) {
        let slot = this.renderRoot.getElementById("main-slot")
        let pages = Object.assign(...slot.assignedElements({flatten: true}).map((e) => ({ [e.dataset.index]: e })))
        
        for (const index in pages) {
           let node = pages[index]
           let mm = this.motionMap[this.slideDirection]
    
           if(index == this.currentItem) {
              if (changes.get("currentItem") == undefined) {
                  node.style[mm.property] = mm.show
              } 
           } else {
                node.style[mm.property] = mm.hide
                if (changes.get("currentItem") != undefined) {
                  node.ontransitionend = () => {
                      pages[this.currentItem].style[mm.property] = mm.show
                      node.ontransitionend = null
                  }
                }
           }
        }
    }

    render() {
      return html`<slot id="main-slot"></slot>`
    }

    static get styles() {
      return css`
          :host {
            display: inline-block;
            box-sizing: border-box;
            overflow: hidden;
            position: relative;
            transition: 0.5s;
          }

          /*  Дочерние элементы подгоняются по размеру к родительскому 
              учитывайте это при добавлении разметки.
          */
          ::slotted(*) {
              position: absolute;
              box-sizing: border-box;
              height: 100%;
              width: 100%;
              margin: 0;
              top: 0px;
              left: 0px;
              transition: 0.3s;
          }
      `
    }
}

window.customElements.define('dz-switcher', DzSwitcher)